import React from 'react';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { makeStyles } from 'tss-react/mui';
import { subDetailsItem } from '../../../pages/PaymentIntegrityPage/PaymentIntegrity.types';

type RendererProps = {
  item: subDetailsItem;
   
  onClaimClick?: (claimId: string) => void;
   
  onMemberClick?: (memberId: string) => void;
};
export const extractClaimId = (value: string) => {
  if (!value) {
    return value;
  }
  return value.split('_')[0];
};

const CLICKABLE_FIELDS = {
  CLAIM: ['Claim', 'First Occurance Claim', 'Primary Claim'],
  MEMBER: ['Member ID'],
};

export const SubDetailValueRenderer = ({
  item,
  onClaimClick,
  onMemberClick,
}: RendererProps) => {
  const { classes } = makeStyles()({
    text: {
      textDecoration: 'dashed',
      textDecorationLine: 'underline',
      textDecorationThickness: '0.5px',
      textUnderlineOffset: '5px',
    },
  })();

  const { label, value } = item;

  const isClaim = CLICKABLE_FIELDS.CLAIM.includes(label) && onClaimClick;

  const isMember = CLICKABLE_FIELDS.MEMBER.includes(label) && onMemberClick;

  if (isClaim) {
    const claimId = extractClaimId(value);

    return (
      <Typography
        fontSize="12px"
        lineHeight="160%"
        fontType="medium"
        textColor={patientAccessTheme.palette.primary[500]}
        className={classes.text}
        cursor="pointer"
        onClick={() => onClaimClick?.(claimId)}
      >
        {claimId}
      </Typography>
    );
  }

  if (isMember) {
    return (
      <Typography
        fontSize="12px"
        lineHeight="160%"
        fontType="medium"
        textColor={patientAccessTheme.palette.primary[500]}
        className={classes.text}
        cursor="pointer"
        onClick={() => onMemberClick?.(value)}
      >
        {value}
      </Typography>
    );
  }

  return (
    <Typography
      fontSize="12px"
      fontType="medium"
      textColor={patientAccessTheme.palette.text.highemphasis}
    >
      {String(value)}
    </Typography>
  );
};
